import React from 'react'
import './Button.css'

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ className, children, type, onClick }) {
  return (
    <button className={className ? 'btn ' + className : 'btn'} type={type} onClick={onClick}>
      {children}
    </button>
  )
}
